import React from 'react';

export const Dot = () => <span className="t-primary">.</span>;
